<template>
  <div class="yunCang">
    <van-form @submit="onSubmit">
      <div class="yunCang_content">
        <div class="yunCang_shop">
          <img
            :src="yunCangList.shop_pic"
            alt=""
            style="width: 0.88rem; height: 0.88rem; margin-right: 0.15rem"
          />
          <p
            style="
              font-size: 0.14rem;
              font-weight: bold;
              color: #333333;
              line-height: 0.2rem;
              height: 0.2rem;
              width: 2.1rem;
            "
          >
            {{ yunCangList.shop_title }}
          </p>
        </div>

        <div class="yunCang_price">
          <van-field
            required
            v-model="phone"
            label="手机号"
            type="username"
            placeholder="请输入手机号码"
          />
          <van-field
            required
            v-model="distributionNum"
            label="配货数量"
            placeholder="请填写配货数量"
          />
        </div>
        <p
          style="
            font-size: 0.12rem;
            color: #999999;
            height: 0.2rem;
            margin-top: 0.14rem;
            width: 3.21rem;
          "
        >
          说明文档：{{ distribution }}
        </p>
      </div>
      <div class="bottom">
        <van-button round type="info" class="MakeSureAdd" native-type="submit"
          >确定</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { getDistribution, getAddDistribution } from "../../api/home";
import { Toast } from "vant";

export default {
  data() {
    return {
      phone: "",
      distributionNum: "", //配货数
      yunCangList: {},
      distribution: "",
    };
  },
  created() {
    if (this.$route.params.val) {
      this.yunCangList = this.$route.params.val;
      sessionStorage.setItem(
        "yunCangVal",
        JSON.stringify(this.$route.params.val)
      );
    } else {
      this.yunCangList = JSON.parse(sessionStorage.getItem("yunCangVal"));
    }

    getDistribution()
      .then((res) => {
        this.distribution = res.data.backdata.text;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  beforeDestroy() {
    sessionStorage.removeItem("yunCangVal");
  },
  methods: {
    // 检测手机号的格式
    isvalidatemobile(phone) {
      const list = [];
      let result = true;
      let msg = "";
      var isPhone = /^1[3456789]\d{9}$/;
      if (phone.length == 11) {
        if (!isPhone.test(phone)) {
          msg = "手机号码格式不正确";
          result = false;
        }
      } else {
        msg = "手机号码长度不为11位";
        result = false;
      }
      list.push(result);
      list.push(msg);
      return list;
    },
    onSubmit(val) {
      if (this.phone == "" || this.distributionNum == "") {
        Toast("手机号或配货数量不能为空");
      } else {
        // 判断手机号是否符合规范
        const validate = this.isvalidatemobile(this.phone);
        if (validate[0]) {
          // if(sessionStorage.getItem('openid'))
          getAddDistribution({
            phone: this.phone,
            num: this.distributionNum,
          })
            .then((res) => {
              console.log(res);
              Toast(res.data.msg);
            })
            .catch((err) => {
              Toast(err);
            });
        } else {
          Toast(validate[1]);
        }
      }
    },
  },
};
</script>

<style lang='scss'>
.yunCang {
  padding: 0.49rem 0 0.22rem 0;
  width: 100%;
  height: 100%;
  // display: flex;
  .van-form {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .yunCang_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .yunCang_shop {
      width: 100%;
      height: 1.1rem;
      background: #ffffff;
      padding: 0.11rem 0.15rem;
      display: flex;
    }
    // 进货价格
    .yunCang_price {
      width: 3.45rem;
      height: 0.89rem;
      margin-top: 0.11rem;
      background: #ffffff;
      border-radius: 0.08rem;
      .van-cell {
        font-size: 0.14rem;
        line-height: 0.24rem;
        padding: 0.1rem 0.16rem;
      }
      .van-cell--required::before {
        margin-left: 0.13rem;
        left: 0.03rem;
        font-size: 0.14rem;
      }
      .van-field__control {
        font-size: 0.14rem;
      }
      .onePrice {
        .van-field__control {
          color: #93683d;
        }
      }

      .van-field__label {
        margin-left: 0.17rem;
        color: #333333;
        font-size: 0.14rem;
      }
    }
  }
  .bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .MakeSureAdd {
      border: none;
      width: 2.72rem;
      height: 0.44rem;
      background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      border-radius: 0.22rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: #93683d;
    }
  }
}
</style>